import Vue from 'vue'

export default Vue.observable({
    user: null,
    loading: null,
    snackbar: null,
    previousRoute: null,
    settings: {
    }
});